export default __webpack_public_path__ + "static/media/sport-img.e576d9e6.webp";